import { FormInput, Button, FormError } from "@/components/Shared";

const PostcodeCheckerForm: React.FC<{
	formik: any;
	children: React.ReactNode;
}> = ({ formik, children }) => {
	return (
		<form onSubmit={formik.handleSubmit}>
			<div className=" pt-3">{children}</div>
			<div className="col-12 col-md-9 pt-3 w-100">
				<FormInput
					name="postcode"
					value={formik.values.postcode}
					handleChange={formik.handleChange}
					placeholder="E.g., SW1A 1AA"
					isRequired={false}
				/>
			</div>
			<div className="row">
				{formik.touched.postcode && formik.errors.postcode ? (
					<FormError message={formik.errors.postcode} theme="dark" />
				) : null}
			</div>
			<div className=" mb-3 col-12 col-md-9 pt-3 w-100">
				<Button
					type="submit"
					name="button"
					title={"Find Deals"}
					isLoading={formik.isSubmitting}
				/>
			</div>
		</form>
	);
};

export default PostcodeCheckerForm;
